import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal, Row, Col, Typography, Button, Spin } from 'antd';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import OrderModal from './Modals/ordermodal';
import OrderRecommendationModal from './Modals/orderrecommendationmodal';
import './ordersetuppage.css';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';

const { Text } = Typography;

@inject(
    'loginStore',
    'orderSetupStore'
)
@observer
class OrderSetupPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.orderSetupStore.initOrderSetup();
    }

    // CHANGED Actions

    // CLICKED Actions

    setIsCreatedClicked = () => {
        this.props.orderSetupStore.setIsCreated(true);
    }

    openOrderModalAndCreateOnClick = () => {
        this.props.orderSetupStore.setOrderModalShown(true);
        this.props.orderSetupStore.setOrderItemDataSources([]);
        this.props.orderSetupStore.initOrderItemDataSource().then(() => {
            this.props.orderSetupStore.initOrderCategoryDataSource();
        });
    }

    openOrderModalAndUpdate = (orderSetupId) => {
        this.props.orderSetupStore.setOrderModalShown(true);
        this.props.orderSetupStore.setOrderItemDataSources([]);
        this.props.orderSetupStore.initOrderItemDataSourceForUpdate(orderSetupId).then(() => {
            this.props.orderSetupStore.initOrderCategoryDataSourceForUpdate(orderSetupId);
        });
    }

    openOrderRecommendationModalAndCreateOrUpdate = (orderSetupId) => {
        this.props.orderSetupStore.setOrderRecommendationModalShown(true);
        this.props.orderSetupStore.setOrderRecommendationItemDataSources([]);
        this.props.orderSetupStore.initOrderRecommendationItemDataSource(orderSetupId).then(() => {
            this.props.orderSetupStore.initOrderRecommendationCategoryDataSource(orderSetupId);
        });
    }

    deleteOrderSetup = (orderSetupId) => {
        this.props.orderSetupStore.deleteOrderSetup(orderSetupId);
    }

    deleteOrderRecommendationSetup = (orderRecommendationSetupId) => {
        this.props.orderSetupStore.deleteOrderRecommendationSetup(orderRecommendationSetupId);
    }

    cancelCreateOrderSetup = () => {
        this.props.orderSetupStore.setIsCreated(false);
    }

    render() {
        const { t } = this.props;
        const {
            isCreated,
            orderSetups,
            orderModalShown,
            orderRecommendationModalShown,
            spinningOrderSetup
        } = this.props.orderSetupStore;

        return (
            <MainContainer title={t('Recommendation Setup')} menukey='recommendation'>

                <Modal
                    title={t('Add Order')}
                    visible={orderModalShown}
                    width={800}
                    footer={null}
                    onCancel={() => this.props.orderSetupStore.setOrderModalShown(false)}
                    zIndex={4000}
                >
                    <OrderModal />
                </Modal>

                <Modal
                    title={t('Manage Recommendation')}
                    visible={orderRecommendationModalShown}
                    width={800}
                    footer={null}
                    onCancel={() => this.props.orderSetupStore.setOrderRecommendationModalShown(false)}
                    zIndex={4000}
                >
                    <OrderRecommendationModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 800, overflow: 'auto' }}>
                            <Spin spinning={spinningOrderSetup}>
                                <Row>
                                    <Col span={24} className='ordersetup-col-container'>

                                        <Row>
                                            <Col span={24} className='ordersetup-col-header'>
                                                <Row>
                                                    <Col span={16} className='ordersetup-col-header-title'>
                                                        <Text className='ordersetup-text-header-title'>{t('Recommendation Setup')}</Text>
                                                    </Col>
                                                    <Col span={8} className='ordersetup-col-header-add'>
                                                        {!isCreated ?
                                                            <Button className='ordersetup-button-header-add' onClick={this.setIsCreatedClicked}>
                                                                <Row>
                                                                    <Col span={24} className='ordersetup-col-header-add-content'>
                                                                        <img src={require('../../../assets/image/Plus.svg')} alt='MenuIcon' className='ordersetup-img-header-add' />
                                                                        <Text className='ordersetup-text-header-button-add'>{t('Add New')}</Text>
                                                                    </Col>
                                                                </Row>
                                                            </Button>
                                                            : null
                                                        }
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col span={24} className='ordersetup-col-title-container'>
                                                <Row>
                                                    <Col span={12} className='ordersetup-col-title-order-container'>
                                                        <Row>
                                                            <Col span={24}>
                                                                <Row>
                                                                    <Col span={12} className='ordersetup-col-title-order-category'>
                                                                        <Text className='ordersetup-text-title-order'>{t('Category > Sub Category')}</Text>
                                                                    </Col>
                                                                    <Col span={12} className='ordersetup-col-title-order-item'>
                                                                        <Text className='ordersetup-text-title-order'>{t('Order Item')}</Text>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col span={12} className='ordersetup-col-title-recommendation-container'>
                                                        <Row>
                                                            <Col span={24}>
                                                                <Row>
                                                                    <Col span={12} className='ordersetup-col-title-recommendation-category'>
                                                                        <Text className='ordersetup-text-title-recommendation'>{t('Category > Sub Category')}</Text>
                                                                    </Col>
                                                                    <Col span={12} className='ordersetup-col-title-recommendation-item'>
                                                                        <Text className='ordersetup-text-title-recommendation'>{t('Recommendation Item')}</Text>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>

                                        {isCreated ? (
                                            <Row>
                                                <Col span={24} className='ordersetup-col-newdata-container'>
                                                    <Row>
                                                        <Col span={12} className='ordersetup-col-newdata-order-container'>
                                                            <Row>
                                                                <Col span={24} className='ordersetup-col-newdata-order' onClick={this.openOrderModalAndCreateOnClick}>
                                                                    <Text className='ordersetup-text-newdata-add'>{t('+ Add Order')}</Text>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col className='ordersetup-col-newdata-arrow'>
                                                            <img src={require('../../../assets/image/ArrowRight.svg')} alt='ArrowRight' className='ordersetup-img-newdata-arrow' />
                                                        </Col>
                                                        <Col span={12} className='ordersetup-col-newdata-recommendation-container'>
                                                            <Row>
                                                                <Col span={24} className='ordersetup-col-newdata-recommendation-disabled'>
                                                                    <Text className='ordersetup-text-newdata-add-disabled'>{t('+ Add Recommendations')}</Text>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={24} className='ordersetup-col-newdata-delete'>
                                                            <Text className='ordersetup-text-newdata-delete' onClick={this.cancelCreateOrderSetup}>{t('Cancel')}</Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        ) : null}

                                        {orderSetups.length === 0 ? null :
                                            orderSetups.map(orderSetup => {
                                                return (
                                                    <Row key={orderSetup.orderSetupId}>
                                                        <Col span={24} className='ordersetup-col-data-container'>
                                                            <Row>
                                                                <Col span={12} className='ordersetup-col-data-order-container'>
                                                                    <Row>
                                                                        <Col span={24} className='ordersetup-col-data-order'>
                                                                            <Row>
                                                                                <Col span={24} className='ordersetup-col-data-order-detail'>
                                                                                    <Row>
                                                                                        <Col span={12} className='ordersetup-col-data-order-detail-category'>
                                                                                            {orderSetup.orderSubCategoryTaskName === null ?
                                                                                                <Text className='ordersetup-text-data-order-detail-category'>
                                                                                                    {orderSetup.orderCategoryTaskName}
                                                                                                </Text>
                                                                                                :
                                                                                                <Text className='ordersetup-text-data-order-detail-category'>
                                                                                                    {orderSetup.orderCategoryTaskName} &gt; {orderSetup.orderSubCategoryTaskName}
                                                                                                </Text>
                                                                                            }
                                                                                        </Col>
                                                                                        <Col span={12} className='ordersetup-col-data-order-detail-item'>
                                                                                            {orderSetup.orderTaskName === null ?
                                                                                                <Text className='ordersetup-text-data-order-detail-item'>--</Text>
                                                                                                :
                                                                                                <Text className='ordersetup-text-data-order-detail-item'>{orderSetup.orderTaskName}</Text>
                                                                                            }
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col className='ordersetup-col-data-arrow'>
                                                                    <img src={require('../../../assets/image/ArrowRight.svg')} alt='ArrowRight' className='ordersetup-img-data-arrow' />
                                                                </Col>
                                                                {orderSetup.orderRecommendationSetups.length === 0 ?
                                                                    <Col span={12} className='ordersetup-col-newdata-recommendation-container'>
                                                                        <Row>
                                                                            <Col span={24} className='ordersetup-col-newdata-recommendation' onClick={() => this.openOrderRecommendationModalAndCreateOrUpdate(orderSetup.orderSetupId)}>
                                                                                <Text className='ordersetup-text-newdata-add'>{t('+ Add Recommendations')}</Text>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    :
                                                                    <Col span={12} className='ordersetup-col-data-recommendation-container'>
                                                                        <Row>
                                                                            <Col span={24} className='ordersetup-col-data-recommendation'>
                                                                                {orderSetup.orderRecommendationSetups.map(orderRecommendationSetup => {
                                                                                    return (
                                                                                        <Row>
                                                                                            <Col span={24} className='ordersetup-col-data-recommendation-detail'>
                                                                                                <Row>
                                                                                                    <Col span={12} className='ordersetup-col-data-recommendation-detail-category'>
                                                                                                        {orderRecommendationSetup.orderRecommendationSubCategoryTaskName === null ?
                                                                                                            <Text className='ordersetup-text-data-recommendation-detail-category'>
                                                                                                                {orderRecommendationSetup.orderRecommendationCategoryTaskName}
                                                                                                            </Text>
                                                                                                            :
                                                                                                            <Text className='ordersetup-text-data-recommendation-detail-category'>
                                                                                                                {orderRecommendationSetup.orderRecommendationCategoryTaskName} &gt; {orderRecommendationSetup.orderRecommendationSubCategoryTaskName}
                                                                                                            </Text>
                                                                                                        }
                                                                                                    </Col>
                                                                                                    <Col span={11} className='ordersetup-col-data-recommendation-detail-item'>
                                                                                                        {orderRecommendationSetup.orderRecommendationTaskName === null ?
                                                                                                            <Text className='ordersetup-text-data-recommendation-detail-item'>--</Text>
                                                                                                            :
                                                                                                            <Text className='ordersetup-text-data-recommendation-detail-item'>{orderRecommendationSetup.orderRecommendationTaskName}</Text>
                                                                                                        }
                                                                                                    </Col>
                                                                                                    <Col span={1} className='ordersetup-col-data-recommendation-detail-remove'>
                                                                                                        <img src={require('../../../assets/image/Trash.svg')} alt='Trash' className='ordersetup-img-data-recommendation-detail-remove' onClick={() => this.deleteOrderRecommendationSetup(orderRecommendationSetup.orderRecommendationSetupId)} />
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    )
                                                                                })}
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                }
                                                            </Row>
                                                            <Row>
                                                                <Col span={24} className='ordersetup-col-data-manage'>
                                                                    <Row>
                                                                        <Col span={7} className='ordersetup-col-data-delete' onClick={() => this.deleteOrderSetup(orderSetup.orderSetupId)}>
                                                                            <Text className='ordersetup-text-data-delete'>{t('Delete this setup')}</Text>
                                                                        </Col>
                                                                        <Col span={5} className='ordersetup-col-data-update'>
                                                                            <img src={require('../../../assets/image/Pencil.svg')} alt='Pencil' className='ordersetup-img-data-update' onClick={() => this.openOrderModalAndUpdate(orderSetup.orderSetupId)} />
                                                                        </Col>
                                                                        <Col span={12} className='ordersetup-col-data-update'>
                                                                            {orderSetup.orderRecommendationSetups.length === 0 ? null :
                                                                                <img src={require('../../../assets/image/Pencil.svg')} alt='Pencil' className='ordersetup-img-data-update' onClick={() => this.openOrderRecommendationModalAndCreateOrUpdate(orderSetup.orderSetupId)} />
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                )
                                            })
                                        }

                                    </Col>
                                </Row>
                            </Spin>
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(OrderSetupPage);